import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Logout from "../components/Logout";
import ChatInput from "./ChatInput";
import axios from "axios";
import { getAllMessagesRoute, sendMessageRoute } from "../utils/APIroutes";
import { v4 as uuidv4 } from "uuid";
import altImage from "../assets/altImage.png";

const ChatContainer = ({ currentChat, currentUser, socket }) => {
  const [messages, setMessages] = useState([]);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const scrollRef = useRef();

  useEffect(() => {
    if (currentChat) {
      const getMsgs = async () => {
        const response = await axios.post(getAllMessagesRoute, {
          from: currentUser._id,
          to: currentChat._id,
        });
        setMessages(response.data);
      };
      if (currentUser !== undefined) {
        getMsgs();
      }
    }
  }, [currentChat]);

  const handleSendMsg = async (msg) => {
    await axios.post(sendMessageRoute, {
      from: currentUser._id,
      to: currentChat._id,
      msg: msg,
    });
    socket.current.emit("send-message", {
      to: currentChat._id,
      from: currentUser._id,
      message: msg,
    });
    const msgs = [...messages];
    msgs.push({ fromSelf: true, message: msg });
    setMessages(msgs);
  };

  useEffect(() => {
    if (socket.current) {
      socket.current.on("msg-recieved", (msg) => {
        console.log(msg);
        setArrivalMessage({ fromSelf: false, message: msg });
      });
    }
  }, [socket]);

  useEffect(() => {
    arrivalMessage &&
      setMessages((prev) => {
        return [...prev, arrivalMessage];
      });
  }, [arrivalMessage]);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behaviour: "smooth" });
  }, [messages]);

  return (
    <>
      {currentChat === undefined ? (
        console.log("first")
      ) : (
        <Container>
          <div className="chat-header">
            <div className="user-details">
              <div className="avatar">
                {currentChat.avatarImage === "" ? (
                  <img src={altImage} alt="avatar" />
                ) : (
                  <img
                    src={`data:image/svg+xml;base64,${currentChat.avatarImage}`}
                    alt="avatar"
                  />
                )}
              </div>
              <div className="username">
                <h3>{currentChat.username}</h3>
              </div>
            </div>
            <Logout />
          </div>

          <div className="chat-messages">
            {messages.length > 0
              ? messages.map((msg) => {
                  return (
                    <div ref={scrollRef} key={uuidv4()}>
                      <div
                        className={`message ${
                          msg.fromSelf ? "sended" : "recieved"
                        }`}
                      >
                        <div className="content">
                          <p>{msg.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })
              : console.log("No messages here")}
          </div>
          <ChatInput handleSendMsg={handleSendMsg} />
        </Container>
      )}
    </>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-rows: 10% 78% 12%;
  gap: 0.1rem;
  overflow: hidden;
  .chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #cccccc2e;
    padding: 2rem;
    .user-details {
      display: flex;
      align-items: center;
      gap: 1rem;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .username {
        h3 {
          color: white;
        }
      }
    }
  }

  .chat-messages {
    padding: 1rem 2rem !important;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: auto;
    &::webkit-scrollbar {
      width: 0.2rem;
      &-thumb {
        background-color: #ffffff39;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
    .message {
      display: flex;
      align-items: center;
      .content {
        max-width: 40%;
        overflow-wrap: break-word;
        font-size: 1.1rem;
        border-radius: 1rem;
        color: #d1d1d1;
        padding: 0.7rem;
        p {
          margin-bottom: 0;
        }
      }
    }
    .sended {
      justify-content: flex-end;
      .content {
        background-color: #4f04ff21;
      }
    }
    .recieved {
      justify-content: flex-start;
      .content {
        background-color: #9900ff20;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .chat-header {
      padding: 1.5rem;
      justify-content: flex-end;
      gap: 1rem;
      .user-details {
        gap: 0.5rem;
        .avatar {
          img {
            height: 2.4rem;
          }
        }
        .username {
          h3 {
            font-size: 1.4rem;
          }
        }
      }
    }

    .chat-messages {
      gap: 0.8rem;
      .message {
        .content {
          max-width: 60%;
          overflow-wrap: break-word;
          font-size: 0.8rem;
          border-radius: 0.4rem;
          padding: 0.3rem;
        }
      }
    }
  }
  @media screen and (max-width: 460px) {
    .chat-header {
      gap: 0.5rem;
      .user-details {
        gap: 0.5rem;
        .avatar {
          img {
            height: 1.4rem;
          }
        }
        .username {
          h3 {
            font-size: 1rem;
            margin: 0;
          }
        }
      }
    }

    .chat-messages {
      gap: 0.8rem;
      .message {
        .content {
          max-width: 60%;
          overflow-wrap: break-word;
          font-size: 0.8rem;
          border-radius: 0.4rem;
          padding: 0.3rem;
        }
      }
    }
  }

  @media screen and (max-width: 320px) {
    .chat-header {
      .user-details {
        .avatar {
          img {
            display: none;
          }
        }
      }
    }
`;

export default ChatContainer;
